import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { count, countUnique, sum } from '@utils/summaries';
import { getMonthInfo } from '@utils/dates';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';
import { REPORT } from '@consts/reports';

export const TotalSuccessfulCutsLastMonth = () => {
    const { firstDay, lastDay } = getMonthInfo(1);

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_LAST_MONTH,
        params: { startDate: firstDay, endDate: lastDay },
    });

    return (
        <BaseReport
            title={'Total Successful Cuts by Location Last Month'}
            rangeText={styleDateRange([firstDay, lastDay])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Company Name', 'Reseller Name', 'Location Name', 'Successful Cuts', 'Rank'],
                data: data.map((item) => [item.companyName, item.resellerName, item.locationName, item.successfulCuts, item.worldRank]),
                summaries: [countUnique, countUnique, count, sum, count],
                sort: [basicSort, basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
